import React, { useState, useEffect } from 'react';
import { X, BookOpen } from 'lucide-react';

const BookPopup = () => {
  // Popup temporarily disabled
  return null;

  // eslint-disable-next-line no-unreachable
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user already saw the popup
    const hasSeenPopup = localStorage.getItem('hasSeenBookPopup');
    
    if (!hasSeenPopup) {
      // Show popup after 20 seconds
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 10000); // 20 seconds

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('hasSeenBookPopup', 'true');
  };

  const handleCTA = () => {
    localStorage.setItem('hasSeenBookPopup', 'true');
    // Link will navigate, no need to set isVisible
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-50 animate-fadeIn"
        onClick={handleClose}
      />
      
      {/* Popup */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        <div 
          className="relative bg-white rounded-3xl shadow-2xl max-w-2xl w-full pointer-events-auto animate-scaleIn flex flex-col"
          style={{ maxHeight: 'min(90dvh, 90vh)' }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button — always visible, sticky to top-right of the card */}
          <button
            onClick={handleClose}
            className="absolute top-3 right-3 z-20 bg-white hover:bg-gray-100 text-gray-600 hover:text-brand-dark-blue w-11 h-11 rounded-full flex items-center justify-center transition-colors shadow-lg"
            aria-label="Zavriet"
          >
            <X size={22} />
          </button>

          <div className="grid grid-cols-1 md:grid-cols-2 overflow-y-auto overscroll-contain rounded-3xl">
            {/* Left side - Book cover */}
            <div className="hidden md:flex bg-gradient-to-br from-brand-dark-blue to-blue-900 p-8 items-center justify-center">
              <div className="text-center">
                <img 
                  src="/obalka-knihy.svg" 
                  alt="Renta bez datumu spotreby" 
                  className="max-w-full h-auto rounded-xl shadow-2xl"
                  style={{maxHeight: '400px'}}
                />
              </div>
            </div>

            {/* Right side - Content */}
            <div className="p-8 pt-12 lg:p-12 lg:pt-14">
              <div className="inline-block bg-brand-orange text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                NOVÁ KNIHA
              </div>
              
              <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-4 text-brand-dark-blue">
                Renta bez dátumu spotreby
              </h2>
              
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Prvá kniha zo série <strong>Gramotnosť ako zbraň</strong>.
                Čítajte kapitoly online - zadarmo, bez registráci, alebo si ju môžete získať zdarma vo fyzickej podobe.
              </p>
              
              <div className="bg-brand-baby-blue bg-opacity-10 rounded-xl p-4 mb-6">
                <p className="text-sm text-gray-700">
                  ✓ Postupne publikované kapitoly<br/>
                  ✓ Videá a komentáre<br/>
                  ✓ Praktické nástroje
                </p>
              </div>
              
              <a
                href="/kniha"
                onClick={handleCTA}
                className="w-full inline-flex items-center justify-center bg-gradient-to-r from-brand-orange to-red-500 hover:from-red-500 hover:to-brand-orange text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-xl text-lg"
              >
                <BookOpen size={24} className="mr-2" />
                Začať čítať knihu
              </a>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes scaleIn {
          from { 
            opacity: 0;
            transform: scale(0.9);
          }
          to { 
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        
        .animate-scaleIn {
          animation: scaleIn 0.4s ease-out;
        }
      `}</style>
    </>
  );
};

export default BookPopup;
